<template>
  <div class="relative">
    <base-input
      :inset="inset"
      with-label
      :label="label"
      type="text"
      :id="`kode_kelompok_barang`"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      fullwidth
      :shadow="false"
      v-model="selected.searchCode"
      @change="onSearch"
    />
    <button
      v-if="withModal && !disabled"
      type="button"
      :class="[
        'absolute cursor-pointer text-gray-400',
        inset ? 'right-4 top-6' : '',
      ]"
      :style="inset ? {} : { top: '2.4rem', right: '0.5rem' }"
      @click="onOpenModal"
    >
      <Icon class="h-5 w-5" icon="heroicons:magnifying-glass-circle-20-solid" />
    </button>

    <product-category-table-modal
      v-if="withModal"
      :visible="visibleModal"
      @close="onCloseModal"
      @click-row="onChange"
    />

    <teleport to="body">
      <loading v-if="loading" />
    </teleport>
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import ProductCategoryTableModal from './ProductCategoryTableModal.vue';
import Teleport from 'vue2-teleport';
import { mapActions } from 'vuex';

export default {
  components: { ProductCategoryTableModal, Teleport },
  mixins: [requestMixin],
  props: {
    value: Object,
    disabled: Boolean,
    required: Boolean,
    label: String,
    placeholder: String,
    withModal: {
      type: Boolean,
      default: true,
    },
    inset: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['input', 'change', 'search', 'open-modal', 'close-modal'],
  data() {
    return {
      loading: false,
      visibleModal: false,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onOpenModal() {
      this.visibleModal = true;

      this.$emit('open-modal');
    },
    onCloseModal() {
      this.visibleModal = false;

      this.$emit('close-modal');
    },
    async onChange(productCategory) {
      this.selected.searchCode = productCategory.attributes.code;

      await this.onSearch();

      this.visibleModal = false;
    },
    async onSearch() {
      this.loading = true;

      const [res, err] = await this.request('/api/v1/product-categories', {
        params: {
          'filter[code]': this.selected.searchCode,
        },
      });

      if (err || !res.data.length) {
        this.selected.searchCode = this.selected.originalCode;

        this.createAlert({
          data: 'Kode tidak ditemukan',
          status: 'error',
        });
      } else {
        const productCategory = res.data[0];

        this.selected.id = productCategory.id;
        this.selected.code = productCategory.attributes.code;
        this.selected.searchCode = productCategory.attributes.code;
        this.selected.originalCode = productCategory.attributes.code;
        this.selected.name = productCategory.attributes.name;
      }

      this.$emit('search');

      this.loading = false;
    },
  },
};
</script>
